import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <section className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">Ammen Consulting SMS Terms & Conditions</h1>
        <p className="terms-updated">
          <span>Last updated:</span> January 2026
        </p>
        <p>
          These SMS Terms & Conditions govern the use of text messaging services
          provided by Ammen Consulting, a professional consulting firm. This
          program is designed to support direct, one-to-one business
          communications between Ammen Consulting personnel and clients or
          business contacts.
        </p>

        <h2 className="terms-section-title">Program Purpose</h2>
        <p>
          Ammen Consulting uses SMS messaging exclusively for conversational,
          informational, and service-related communications. Typical use cases
          include project coordination, scheduling, follow-ups, and client
          support. SMS messaging is not used for marketing, promotional
          campaigns, mass messaging, or automated notifications.
        </p>

        <h2 className="terms-section-title">Opt-In Requirements</h2>
        <p>Recipients may opt in to receive SMS messages by:</p>
        <ul className="terms-list">
          <li>Initiating a text message to an Ammen Consulting phone number, or</li>
          <li>
            Providing explicit verbal or written consent during an existing
            business relationship.
          </li>
        </ul>
        <p>
          Opt-in is limited to individuals with an established business
          relationship with Ammen Consulting.
        </p>

        <h2 className="terms-section-title">Message Frequency</h2>
        <p>
          Message frequency varies based on the nature of the business
          relationship and ongoing communications.
        </p>

        <h2 className="terms-section-title">Opt-Out Instructions</h2>
        <p>
          Recipients may opt out of SMS communications at any time by replying{" "}
          <strong>STOP</strong>. Upon opting out, no further messages will be
          sent unless the recipient replies <strong>START</strong> to
          re-subscribe.
        </p>

        <h2 className="terms-section-title">Help & Support</h2>
        <p>
          For assistance, reply <strong>HELP</strong> or contact Ammen Consulting
          at <strong>info@ammenconsulting.com</strong>.
        </p>

        <h2 className="terms-section-title">Carrier & Fees Disclosure</h2>
        <p>
          Message and data rates may apply. SMS delivery is subject to mobile
          carrier availability and network conditions.
        </p>

        <h2 className="terms-section-title">Program Changes</h2>
        <p>
          Ammen Consulting reserves the right to modify or terminate this SMS
          program at any time. Updated terms will be posted on this page.
        </p>

        <hr className="terms-divider" />

        <p className="terms-disclaimer">
          By using this SMS program, you agree to these terms and conditions.
        </p>
      </div>
    </section>
  );
};

export default TermsAndConditions;
